
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.6667 8.88835C16.6667 7.65067 16.175 6.46369 15.2998 5.58852C14.4247 4.71335 13.2377 4.22168 12 4.22168C10.7623 4.22168 9.57534 4.71335 8.70017 5.58852C7.825 6.46369 7.33334 7.65067 7.33334 8.88835C7.33334 14.3328 5 15.8884 5 15.8884H19C19 15.8884 16.6667 14.3328 16.6667 8.88835Z","stroke":"#10001F","stroke-width":"1.7","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.3454 18.9995C13.2087 19.2352 13.0124 19.4309 12.7763 19.5669C12.5401 19.7029 12.2724 19.7745 11.9999 19.7745C11.7273 19.7745 11.4596 19.7029 11.2235 19.5669C10.9873 19.4309 10.791 19.2352 10.6543 18.9995","stroke":"#10001F","stroke-width":"1.7","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"4.5","cy":"4.5","r":"4.5","transform":"matrix(-1 0 0 1 22 1)","fill":"#FF7900","stroke":"white","stroke-width":"1.7"}})])
          )
        }
      }
    